import UAParser from 'ua-parser-js'

export const getUserBrowser = (userAgent: string | undefined) => {
  if (!userAgent) {
    return null
  }

  const parser = new UAParser(userAgent)
  const { name, version } = parser.getBrowser()

  return { name, version }
}
